'use strict';

exports.SimpleLinearRegression = exports.SLR = require('./regression/simple-linear-regression');
//exports.MultipleLinearRegression = exports.MLR = require('./regression/multiple-linear-regression');
//exports.MultivariateLinearRegression = exports.MVLR = require('./regression/multivariate-linear-regression');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-regression/src/index.js
 ** module id = 97
 ** module chunks = 0
 **/